import '../../utils/moment-extensions';

/**
 * Batch dates into contiguous groups
 * Example: ['Jan 1', 'Jan 2', 'Jan 4'] => [['Jan 1', 'Jan 2'], ['Jan 4']]
 * @param {Array<moment>} dates
 * @param {int} batchSize
 * @returns {Array<Array<moment>>}
 */
export default function batchDates(dates) {
    let currentBatch = [];
    let prevDate;

    const batches = [];
    const flushTimes = function flushTimes() {
        if (currentBatch.length > 0) {
            batches.push(currentBatch);
        }
        currentBatch = [];
    };

    for (let i = 0; i < dates.length; i++) {
        if (prevDate && prevDate.dayDiff(dates[i]) < -1) {
            flushTimes();
        }

        currentBatch.push(dates[i]);
        prevDate = dates[i];
    }

    flushTimes();

    return batches;
}
